import React from 'react'
import * as S from './style'

const ConfirmationButton = ({ title, onClick }) => {
  return (
    <>
      <S.Button onClick={onClick}>
        <S.Text>{title}</S.Text>
      </S.Button>
    </>
  )
}

export { ConfirmationButton }
